import styled from 'styled-components'

export const Link = styled.a`
  text-decoration: none;
`

export const LinkWithGrow = styled(Link)`
  flex-grow: 1;
`

export const FlagContainer = styled.div`
  margin: 25px 22px 17px;
  max-width: 249px;
  height: 18px;
`

export const VehicleInfo = styled.div`
  width: 100%;
`

export const Text = styled.div`
  font-size: ${props => `${props.size}px`};
  color: ${props => (props.color ? props.color : '#AEAEBA')};
  font-weight: ${props => (props.weight ? props.weight : '500')};
  text-transform: ${props => (props.uppercase ? 'uppercase' : 'none')};
  margin: ${props => (props.margin ? props.margin : '0px')};
  font-style: normal;
  line-height: 150%;
  position: relative;
`

export const ZeroStripes = styled.div`
  background-image: url('/assets/img/zero-stripes.svg');
  position: absolute;
  width: 142px;
  height: 145px;
  left: 108px;
  top: 10px;
`
